import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { MenuItem } from 'react-bootstrap';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar';
import {
  changeDate,
  changeOutletShift,
  exportShiftRequest,
} from 'actions/reports/shifts';
import moment from 'moment';
import Dropdown from 'components/Dropdown';
import OutletModal from 'components/Fields/ReduxForm/OutletModal';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import styles from './ActionBar.css';
import { getFormattedTime } from '../../../../utils/hourFilter';

class ActionBar extends React.Component {
  render() {
    const { outlets, showModalOutletMobileState } = this.props;

    return (
      <div>
        <div className={styles.wrapper}>
          <MenuTitle menuTitle="Shift" />
          {!isFullSiteMode() && (
            <div className="col-md-6 col-lg-6 visible-md visible-lg no-padding export-shift">
              <div className="pull-right dropdown-export">
                <Dropdown>
                  <Dropdown.Toggle
                    title="Export"
                    bsStyle="primary"
                  ></Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem onSelect={this._onClickExportButton}>
                      Detail Shift
                    </MenuItem>
                    <MenuItem divider />
                    <MenuItem
                      onSelect={this._onClickExportButton}
                      eventKey={'expense'}
                    >
                      Detail - Expense
                    </MenuItem>
                    <MenuItem divider />
                    <MenuItem
                      onSelect={this._onClickExportButton}
                      eventKey={'income'}
                    >
                      Detail - Income
                    </MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          )}
          <div style={{ paddingTop: '20px' }}>
            <div className="row">
              <div className="col-sm-12 col-xs-12 col-md-10 col-lg-8">
                <div
                  className={`form-group pull-left visible-md visible-lg ng-scope ${
                    styles['form-group']
                  }`}
                >
                  <Field
                    component={DropdownOutlet}
                    outlets={outlets}
                    onChangeOutletIds={this._onChangeOutlet}
                    name="outlet"
                    allOutletOption
                  />
                </div>
                <div className={`form-group no-margin`}>
                  <Field
                    component={DropdownCalendar}
                    name="date"
                    onChange={this._onChangeDate}
                    updateServerOnChange
                  />
                </div>
              </div>
              <Field
                component={OutletModal}
                name="outlet"
                outlets={outlets || []}
                onChangeOutletIds={this._onChangeOutlet}
                allOutletOption
                show={showModalOutletMobileState}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onChangeOutlet = outletIds => {
    const { isMobile } = this.props;
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletShift(outletIds, formattedStart, formattedEnd, isMobile)
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { isMobile } = this.props;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(changeDate(formattedStart, formattedEnd, isMobile));
  };

  _onClickExportButton = reportType => {
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
      outlet,
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    const filename = `Report Shifts - ${dateLabel}`;

    this.props.dispatch(
      exportShiftRequest(
        {
          start: formattedStart,
          end: formattedEnd,
          type: reportType,
        },
        filename,
        outlet[0]
      )
    );
  };
}

const mapForm = {
  form: 'search',
};

const selector = formValueSelector('search');

function mapStateToProps(state) {
  return {
    outlets: state.reports.shifts.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionBar)
);
